import { AnyAction } from 'redux';
import { setRequestStatus } from 'data-layer-cr/dist/network';

import { AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';
import processRequest from '../../../services/processRequest';
import CoverageCatalogResponse from '../../../models/responseTypes/CoverageCatalogResponse';
import { REQUEST_COVERAGE_CATALOG } from '../requestIdentifiers';

// Slice Methods
import {
  setCoverageCatalogs,
  setProductConfiguration,
} from '../slice/coverageCatalogSlice';

// eslint-disable-next-line import/prefer-default-export
export const requestCoverageCatalogs =
  (
    productId: string,
    userId: string,
    profileId: number,
    vehicleUse: string,
  ): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_COVERAGE_CATALOG, 'requesting'));
    try {
      const response = await processRequest<CoverageCatalogResponse>({
        method: 'GET',
        url: `Catalog/products/coverages?Code=${productId}&userId=${userId}&profileId=${profileId}&vehicleuse=${vehicleUse}`,
      });
      dispatch(setCoverageCatalogs(response.coverages));
      dispatch(setProductConfiguration(response.config));

      return dispatch(setRequestStatus(REQUEST_COVERAGE_CATALOG, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(REQUEST_COVERAGE_CATALOG, 'failure'));
    }
  };
